const amountComponentWrapper = () => {
  return {
    restrict: "E",
    template: require("./template.html"),
    transclude: true,
    scope: {
      headline: "@",
      errorType: "@",
    },
    link: (scope, element) => {
      scope.id = scope.headline.toLowerCase().replace(/\s/g, "_") + "_wrapper";

      // Validation stubbing for customer application inputs
      if (!scope.errorType) return;
      if (scope.errorType.indexOf(" ") >= 0) {
        scope.errorTypes = scope.errorType.split(" ");
      }
      const resetInputsAndModelsArr = () => {
        scope.models = [];
        scope.inputElements = element.find("input,select");
        const ctrlScope = scope.$parent;
        let inputId;
        for (let i = 0; i < scope.inputElements.length; i++) {
          inputId = scope.inputElements[i].name;
          if (ctrlScope.form[inputId] === undefined) continue;
          scope.models.push({
            model: ctrlScope.form[inputId],
            input: scope.inputElements[i]
          });
        }
      }

      const clearInputValue = (input) => {
        switch (input.type) {
          case "radio":
          case "checkbox":
            input.checked = false;
            break;
          default:
            input.value = null;
        }
      }

      const invalidateInputs = () => {
        let currentModel;
        for (let i = 0; i < scope.models.length; i++) {
          clearInputValue(scope.models[i].input)
          angular.element(scope.models[i].input).addClass("form__alert");
          currentModel = scope.models[i].model;
          if (scope.errorTypes) {
            for (let i = 0; i < scope.errorTypes.length; i++) {
              currentModel.$setValidity(scope.errorTypes[i], false);
            }
          } else {
            currentModel.$setValidity(scope.errorType, false);
          }
          currentModel.$dirty = true;
          scope.isValid = false;
        }
      };

      const validateInputs = () => {
        let currentModel;
        for (let i = 0; i < scope.models.length; i++) {
          angular.element(scope.models[i].input).removeClass("form__alert");
          currentModel = scope.models[i].model;
          if (scope.errorTypes) {
            for (let i = 0; i < scope.errorTypes.length; i++) {
              currentModel.$setValidity(scope.errorTypes[i], true);
            }
          } else {
            currentModel.$setValidity(scope.errorType, true);
          }
          scope.isValid = true;
        }
      };

      scope.toggleValidationState = () => {
        resetInputsAndModelsArr();
        scope.isValid ? invalidateInputs() : validateInputs();
      };

      scope.isValid = true;
      resetInputsAndModelsArr();
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountComponentWrapper", amountComponentWrapper);
